/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { PureComponent } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import ValueCalculation from '../value-calculation';
import IconButton from '../../../button/IconButton';

class ValueCalculationModal extends PureComponent {

  state = {
    display: false,
  };

  toggle = (e) => {
    e.preventDefault();
    this.setState({ display: !this.state.display });
  }

  render() {
    const { surveyId, utrCode } = this.props;

    return (
      <>
        <IconButton
          tooltip='View calculation'
          color='transparent'
          outline={false}
          onClick={this.toggle}
          icon='fal fa-calculator text-ThemeAccentMedium'
        >
          {this.props.text && <small>{this.props.text}</small>}
        </IconButton>
        <Modal className='modal-lg' isOpen={this.state.display} toggle={this.toggle} backdrop='static'>
          <ModalHeader toggle={this.toggle}>Calculation</ModalHeader>
          <ModalBody>
            <ValueCalculation surveyId={surveyId} utrCode={utrCode} isVisible={this.state.display} />
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default ValueCalculationModal;
